import React, { useState } from "react";
import CustomTabs from "components/tabs/customTab";
import { Gift, ShoppingCart, TrendingUp, Trophy, Sparkles } from "lucide-react";
import AwardCreditSummaryCard from "./AwardCreditSummaryCard";
import RewardCategoryCard from "./RewardCategoryCard";
import RecentActivitySummary from "./RecentActivitySummary";
import OverviewSummaryCard from "./OverviewSummaryCard";
import MilestoneSummary from "./MilestoneSummary";
import LeaderboardSummary from "./LeaderboardSummary";
import HyvidPointsPurchase from "./HyvidPointsPurchase";
import Nominations from "./Nominations";


const HyvidRewardsTab = () => {
  const [activeTab, setActiveTab] = useState("credits");

  const TabLabel = ({ text, icon: Icon }) => {
    return (
      <div className="flex items-center justify-center gap-2">
        <span>{<Icon className="h-4 w-4" />}</span>
        <span className="text-sm font-medium">{text}</span>
      </div>
    );
  };
  const tabOptions = [
    {label: <TabLabel icon={Gift} text="Award Credits" />, value: "credits"},
    {label: <TabLabel icon={Sparkles} text="My Nominations" /> ,value: "nominations"},
    {label: <TabLabel icon={TrendingUp} text="Overview" /> ,value: "overview"},
    {label: <TabLabel icon={Trophy} text="Leaderboard" />, value: "leaderboard"},
    {label: <TabLabel icon={ShoppingCart} text="Purchase" />, value: "purchase"},
  ];

  return (
    <div className="flex flex-col gap-4">
      <CustomTabs
        tabs={tabOptions}
        height="h-10"
        activeTab={activeTab}
        onChange={setActiveTab}
      />
      <div className="mt-3 space-y-4">
        {activeTab === "credits" &&
          <div className="space-y-6">
            <AwardCreditSummaryCard/>
            <RewardCategoryCard/>
            <MilestoneSummary/>
          </div>
        }
        {activeTab === "nominations" &&
          <div className="space-y-6">
            <Nominations/>
          </div>
        }
        {activeTab === "overview" &&
          <div className="space-y-6 ">
            <OverviewSummaryCard/>
            <RecentActivitySummary/>
          </div>
        }
        {activeTab === "leaderboard" &&
          <div className="space-y-6 ">
            <LeaderboardSummary/>
          </div>
        }
        {activeTab === "purchase" &&
          <div className="space-y-6">
            <HyvidPointsPurchase/>
          </div>
        }
      </div>
    </div>
  );
};

export default HyvidRewardsTab;
